import { C } from '#integrations';
import styles from './MenuItem.module.css';
export const classNameMap = ({ disabled, isActive, kind, }) => {
    if (disabled) {
        return C(styles.Content, styles.Disabled);
    }
    if (isActive) {
        return C(styles.Content, styles.Active);
    }
    if (kind === 'danger') {
        return C(styles.Content, styles.Danger);
    }
    return C(styles.Content, styles.Standard);
};
